import { mapState } from 'vuex'
import { KEY_ENTER } from '@/helpers/keyCodes'
import { wait } from '@/helpers/time'
import { GTM_EVENT_LABELS } from '@/services/external-communication/gtm/gtm-events'
import EmailSubscriptionService from '@/api/services/_shared/email-subscription-service'

export const SOURCES = {
  popup: 'Website Newsletter Overlay',
  footer: 'Website Newsletter Footer',
}

const REQUEST_STATES = {
  initial: 0,
  submitting: 1,
  error: 2,
  success: 3,
}

export default {
  data() {
    return {
      $newsletterSignup_email: '',
      $newsletterSignup_hideErrorMessage: false,
      $newsletterSignup_errorMessage: null,
      $_newsletterSignup_requestState: REQUEST_STATES.initial,
      $_newsletterSignup_submitAttempt: 0,
      $_newsletterSignup_invalidEmailError: this.$t('errors.invalid_email'),
    }
  },

  computed: {
    ...mapState({
      $_newsletterSignup_hostname: state => state.page.hostname,
      $_newsletterSignup_locale: state => state.page.locale,
    }),

    $newsletterSignup_hasErrorMessage() {
      return this.$data.$newsletterSignup_errorMessage !== null
    },

    $newsletterSignup_isRequestStateSubmitting() {
      return this.$data.$_newsletterSignup_requestState === REQUEST_STATES.submitting
    },

    $newsletterSignup_isRequestStateError() {
      return this.$data.$_newsletterSignup_requestState === REQUEST_STATES.error
    },

    $newsletterSignup_isRequestStateSuccess() {
      return this.$data.$_newsletterSignup_requestState === REQUEST_STATES.success
    },
  },

  methods: {
    $newsletterSignup_handleEmailInputChange(formData) {
      if (this.$data.$_newsletterSignup_submitAttempt > 0) {
        this.$data.$newsletterSignup_errorMessage = On.helpers.validateEmail(formData.email)
          ? null
          : this.$data.$_newsletterSignup_invalidEmailError
      }
      if (formData.event.keyCode === KEY_ENTER) this.$newsletterSignup_submit(formData)
    },

    $newsletterSignup_submit(formData) {
      const state = this.$data.$_newsletterSignup_requestState
      this.$data.$_newsletterSignup_submitAttempt++
      if (state == REQUEST_STATES.submitting || state == REQUEST_STATES.success) return
      if (!On.helpers.validateEmail(formData.email))
        return this.$_newsletterSignup_setInvalidEmailErrorMessage()
      this.$data.$newsletterSignup_errorMessage = null
      this.$data.$_newsletterSignup_requestState = REQUEST_STATES.submitting
      formData.source === SOURCES.footer
        ? this.$_newsletterSignup_subscribeToNewsletterWithCors(formData)
        : this.$_newsletterSignup_subscribeToNewsletter(formData)
    },

    $newsletterSignup_onSuccess() {
      // template method > overwrite on demand
    },

    $newsletterSignup_onError() {
      // template method > overwrite on demand
    },

    async $_newsletterSignup_setInvalidEmailErrorMessage() {
      if (this.$data.$newsletterSignup_errorMessage) {
        // make it flash every time the submit button is clicked
        this.$data.$newsletterSignup_hideErrorMessage = true
        await wait(100)
        this.$data.$newsletterSignup_hideErrorMessage = false
      }
      this.$data.$newsletterSignup_errorMessage = this.$data.$_newsletterSignup_invalidEmailError
    },

    $_newsletterSignup_subscribeToNewsletterWithCors({ email, gender, source }) {
      const variables = { email, gender, source }
      this.$http
        .post(
          `${this.$_newsletterSignup_hostname}/${this.$_newsletterSignup_locale}/newsletter/subscribe`,
          variables
        )
        .then(() => this.$_newsletterSignup_onSuccessfulSubscription({ email, source }))
        .catch(() => this.$_newsletterSignup_onUnsuccessfulSubscription())
    },

    async $_newsletterSignup_subscribeToNewsletter({ email, gender, source, listId }) {
      const variables = {
        attributes: {
          email,
          listId,
          isSubscribingToNewsletter: true,
          gender,
          subscriptionType: source,
        },
      }
      if (await EmailSubscriptionService.registerToMailingList(variables)) {
        this.$_newsletterSignup_onSuccessfulSubscription({ email, source })
      } else {
        this.$_newsletterSignup_onUnsuccessfulSubscription()
      }
    },

    $_newsletterSignup_onSuccessfulSubscription({ email, source }) {
      this.$data.$_newsletterSignup_requestState = REQUEST_STATES.success
      this.$dyClient.trackNewsletterSubscription(email)
      this.$_newsletterSignup_trackEvent(source)
      this.$newsletterSignup_onSuccess()
    },

    $_newsletterSignup_onUnsuccessfulSubscription() {
      this.$data.$_newsletterSignup_requestState = REQUEST_STATES.error
      setTimeout(() => (this.$data.$_newsletterSignup_requestState = REQUEST_STATES.initial), 3000)
      this.$newsletterSignup_onError()
    },

    $_newsletterSignup_trackEvent(source) {
      const action = source === SOURCES.footer ? 'footer' : 'newsletter_overlay'
      this.$notifier.trackEvent({
        action: this.$notifier.ACTIONS.subscriptions,
        details: { action, label: GTM_EVENT_LABELS.subscribed },
      })
    },
  },
}
